export const standardDateFormat = (date: Date | string) =>
  new Date(date).toLocaleDateString('en-US', {year: 'numeric', month: 'long', day: 'numeric'})
